export default __webpack_public_path__ + "static/media/phone_header.689976e4.svg";